const zh = {
  inv: '盘点',
  trade: '交易',
  transfer: '调拨',
  temporary: '临时',
  inbound: '入库',
  outbound: '出库',
  scanOrder: '扫描单',
  inputOrder: '输入单',
  beConfirmed: '待确认',
  confirmed: '已确认',
  invInProgress: '盘点进行中',
  genertDifferences: '生成差异中',
  cpletDifIn: '完成差异入库',
  cpletDifOut: '完成差异出库',
  cplet: '已完成',
  inboundSuccess: '入库成功',
  outboundSuccess: '出库成功',
  conIn: '确定入库',
  conOut: '确定出库',
  perOutbound: '预出库',
  normalType: "普通物料",
  completeType: "成品",
  wastedType: "废弃料",
  tempType: "临时(中转)库位",
  locationType: "库位类型",
  outter: "外部库位/海外库位",
  productionType: "生产库位",
  defectiveReturnType: "不良品退货库位",
  defectiveTempType: "不良品临时库位",

  locLocked: "库位已锁定/盘点中",
  preOutExsist: "库位存在预出库",
  locNull: "库位不存在",
  proQtyFalse: "产品数量不匹配",
  calcErr: "计算订单库位异常",
  inventoryOrder: "出入库单",
  list: "历史记录",
  batchAdd: "入库",
  adjust: "出库",
  count: "盘点",
  batchNo: "批次号",
  opType: "操作类型",
  beforeCount: "变更前数量",
  changeCount: "变更数量",
  afterCount: "变更后数量",
  createdAt: "创建时间",
  inventoryType: "出入库类型",
};

export default zh;